<div class="sidenav-header">
    <i class="fas fa-times p-3 cursor-pointer text-secondary opacity-5 position-absolute end-0 top-0 d-none d-xl-none" aria-hidden="true" id="iconSidenav"></i>
    <a class="navbar-brand m-0" [class.text-center]="is_mini" target="_blank">
        <img [src]="(is_mini)? './assets/img/iso-logo-green.png' : './assets/img/logo-1.png'" class="navbar-brand-img mb-3" [class.logo-mini]="is_mini" [class.logo-normal]="!is_mini"  alt="main_logo">
        <div *ngIf="!is_mini" class="version-text">
            <span class="font-weight-bold">
                {{ 'COMMON.VERSION' | translate }}
            </span> 
            <span class="ms-2 text-primary">{{ admin_version }}</span> / 
            <span>{{ project_version }}</span>
            <br><span>{{ user_role }}</span>
            <!-- / <span>{{ project_name }}</span> -->
        </div>
    </a>
    
</div>
<hr class="horizontal dark mt-5 mb-3">

<div class="collapse navbar-collapse w-auto h-auto" id="sidenav-collapse-main">
    <ul class="navbar-nav">
        <li class="nav-item mb-0" *ngFor="let section of MenuSections">
            <ng-container *ngIf="canShow(section) && section.group == 'primary'">
                <a *ngIf="section.route" class="nav-link" [routerLink]="section.route" routerLinkActive="active">
                    <div class="icon icon-sm shadow-sm border-radius-md bg-white text-center d-flex align-items-center justify-content-center me-2">
                        <i [class]="section.icon"></i>
                    </div>
    
                    <span class="nav-link-text ms-1">{{ section.title | translate }}</span>
                </a>
                
                <ng-container *ngIf="!section.route">
                    <a class="nav-link d-flex justify-content-between align-items-center" (click)="toggle(section.id)">
                        <div class="d-flex align-items-center">
                            <div class="icon icon-sm shadow-sm border-radius-md bg-white text-center d-flex align-items-center justify-content-center me-2">
                                <i [class]="section.icon"></i>
                            </div>
    
                            <span class="nav-link-text ms-1">{{ section.title | translate }}</span>
                        </div>
    
                        <div class="arrow-wrapper" [class.rotate]="collapse[section.id]">
                            <i class="ni ni-bold-down"></i>
                        </div>
                    </a>
    
                    <div class="smooth-collapse" [class.open]="collapse[section.id]">
                        <div class="smooth-content">
                            <ul class="nav ms-4 ps-3">
                                <ng-container *ngFor="let item of section.items">
                                    <li class="nav-item" *ngIf="canShow(item)">
                                        <a class="nav-link" [routerLink]="item.route" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: item.active_exact || false }">
                                            <span class="sidenav-mini-icon">{{ item.mini_icon }}</span>
                                            <span class="sidenav-normal">{{ item.title | translate }}</span>
                                        </a>
                                    </li>
                                </ng-container>
                            </ul>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </li>

        <li class="nav-item">
            <hr class="horizontal dark" />
            <h6 class="ps-4 mt-1 ms-2 text-uppercase text-xs font-weight-bolder opacity-6 sidenav-normal" [class.logo-mini]="!is_mini">{{ 'MENU.MODULES' | translate }}</h6>
            <h6 class="ps-4 mt-1 ms-2 text-uppercase text-xs font-weight-bolder opacity-6 sidenav-mini-icon" [class.logo-mini]="is_mini">M</h6>
        </li>

        <li class="nav-item" *ngFor="let section of MenuSections">
            <ng-container *ngIf="canShow(section) && section.group == 'secondary'">
                <a *ngIf="section.route" class="nav-link" [routerLink]="section.route" routerLinkActive="active">
                    <div class="icon icon-sm shadow-sm border-radius-md bg-white text-center d-flex align-items-center justify-content-center me-2">
                        <i [class]="section.icon"></i>
                    </div>
    
                    <span class="nav-link-text ms-1">{{ section.title | translate }}</span>
                </a>
    
                <ng-container *ngIf="!section.route">
                    <a class="nav-link d-flex justify-content-between align-items-center" (click)="toggle(section.id)">
                        <div class="d-flex align-items-center">
                            <div class="icon icon-sm shadow-sm border-radius-md bg-white text-center d-flex align-items-center justify-content-center me-2">
                                <i [class]="section.icon"></i>
                            </div>
    
                            <span class="nav-link-text ms-1">{{ section.title | translate }}</span>
                        </div>
    
                        <div class="arrow-wrapper" [class.rotate]="collapse[section.id]">
                            <i class="ni ni-bold-down"></i>
                        </div>
                    </a>
    
                    <div class="smooth-collapse" [class.open]="collapse[section.id]">
                        <div class="smooth-content">
                            <ul class="nav ms-4 ps-3">
                                <ng-container *ngFor="let item of section.items">
                                    <li class="nav-item" *ngIf="canShow(item)">
                                        <a class="nav-link" [routerLink]="item.route" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: item.active_exact || false }">
                                            <span class="sidenav-mini-icon">{{ item.mini_icon }}</span>
                                            <span class="sidenav-normal">{{ item.title | translate }}</span>
                                        </a>
                                    </li>
                                </ng-container>
                            </ul>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </li>

        <li class="nav-item">
            <hr class="horizontal dark" />
            <h6 class="ps-4  ms-2 text-uppercase text-xs font-weight-bolder opacity-6 sidenav-normal">{{ 'MENU.SUPPORT' | translate }}</h6>
            <h6 class="ps-4  ms-2 text-uppercase text-xs font-weight-bolder opacity-6 sidenav-mini-icon" [class.logo-mini]="is_mini">S</h6>
        </li>
        
        <li class="nav-item mb-0" *ngFor="let section of MenuSections">
            <ng-container *ngIf="canShow(section) && section.group == 'tertiary'">
                <a *ngIf="section.route" class="nav-link" [routerLink]="section.route" routerLinkActive="active">
                    <div class="icon icon-sm shadow-sm border-radius-md bg-white text-center d-flex align-items-center justify-content-center me-2">
                        <i [class]="section.icon"></i>
                    </div>
    
                    <span class="nav-link-text ms-1">{{ section.title | translate }}</span>
                </a>
                
                <ng-container *ngIf="!section.route">
                    <a class="nav-link d-flex justify-content-between align-items-center" (click)="toggle(section.id)">
                        <div class="d-flex align-items-center">
                            <div class="icon icon-sm shadow-sm border-radius-md bg-white text-center d-flex align-items-center justify-content-center me-2">
                                <i [class]="section.icon"></i>
                            </div>
    
                            <span class="nav-link-text ms-1">{{ section.title | translate }}</span>
                        </div>
    
                        <div class="arrow-wrapper" [class.rotate]="collapse[section.id]">
                            <i class="ni ni-bold-down"></i>
                        </div>
                    </a>
    
                    <div class="smooth-collapse" [class.open]="collapse[section.id]">
                        <div class="smooth-content">
                            <ul class="nav ms-4 ps-3">
                                <ng-container *ngFor="let item of section.items">
                                    <li class="nav-item" *ngIf="canShow(item)">
                                        <a class="nav-link" [routerLink]="item.route" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: item.active_exact || false }">
                                            <span class="sidenav-mini-icon">{{ item.mini_icon }}</span>
                                            <span class="sidenav-normal">{{ item.title | translate }}</span>
                                        </a>
                                    </li>
                                </ng-container>
                            </ul>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </li>
    </ul>
</div>

<div class="sidenav-footer mx-3 mt-3 pt-3 mb-5">
    <div class="card card-background shadow-none card-background-mask-secondary" id="sidenavCard">
        <div class="full-background" style="background-image: url('assets/img/curved-images/white-curved.jpg')"></div>
        <div class="card-body text-start p-3 w-100">
            <div class="icon icon-shape icon-sm bg-white shadow text-center mb-3 d-flex align-items-center justify-content-center border-radius-md">
                <i class="ni ni-diamond text-dark text-gradient text-lg top-0" aria-hidden="true" id="sidenavCardIcon"></i>
            </div>
            <div class="docs-info">
                <h6 class="text-white up mb-0">{{ 'MENU.NEED_HELP' | translate }}</h6>
                <p class="text-xs font-weight-bold">{{ 'MENU.PLEASE_CONTAC_US' | translate }}</p>
                <a class="btn btn-white btn-sm w-100 mb-0" routerLink="/faq/list">{{ 'MENU.FAQ' | translate }}</a>
            </div>
        </div>
    </div>
</div>